import ApiExec, { ApiExecDecrypted } from '@utils/ApiExec';

class PpmServices {
  getPersonsInfo = (params) => {
    return ApiExec(params, 'ppm/get-AboutUs', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  setPersonInfo = (params) => {
    return ApiExecDecrypted(params, 'ppm/set-person-AboutUs', 'POST', false)
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  updatePersonInfo = (params) => {
    return ApiExecDecrypted(params, 'ppm/update-person-AboutUs', 'PUT', false)
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  // Banners
  getBanners = (params) => {
    return ApiExec(params, 'ppm/get-banners', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  setBanner = (params) => {
    return ApiExecDecrypted(params, 'ppm/set-banner', 'POST', false)
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  updateBanner = (params) => {
    return ApiExecDecrypted(params, 'ppm/update-banner', 'PUT', false)
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  deleteBanner = (params) => {
    return ApiExec(params, 'ppm/delete-banner', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  getEventsGallery = (params) => {
    return ApiExec(params, 'ppm/get-events-gallery', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  getGalleryByEvent = (params) => {
    return ApiExec(params, 'ppm/get-gallery-by-event', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  getGalleryTable = (params) => {
    return ApiExec(params, 'ppm/get-gallery-table', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  setEventGallery = (params) => {
    return ApiExec(params, 'ppm/set-event-gallery', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  updateEventGallery = (params) => {
    return ApiExecDecrypted(params, 'ppm/update-event-gallery', 'PUT', false)
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };

  deleteEventGallery = (params) => {
    return ApiExec(params, 'ppm/delete-event-gallery', 'POST')
      .then((res) => res)
      .then((res) => res)
      .catch((error) => error);
  };
}

const compromiso = new PpmServices();
export default compromiso;
